import { useNavigate } from 'react-router-dom';
import { UsePaymentLinkService } from '../types';

const usePaymentLink = (): UsePaymentLinkService => {
  const navigate = useNavigate();
  const onNavigate = () => {
    navigate(`/create-payment-link`);
  };
  return { onNavigate };
};

export default usePaymentLink;
